module.exports = __webpack_public_path__ + "img/step1.cf547a59.svg";